import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: SidebarNavigationState = {
    selectedMenu: null,
};

export const sidebarNavigationSlice = createSlice({
    name: "sidebarNavigation",
    initialState,
    reducers: {
        setSelectedMenu: (state, action: PayloadAction<string>) => {
            state.selectedMenu = action.payload;
        }
    },
});

export interface SidebarNavigationState {
    selectedMenu: string;
}

export const sidebarNavigationAction = sidebarNavigationSlice.actions;

export default sidebarNavigationSlice.reducer;
